import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Registration from './components/Registration';
import Awards from './components/Awards';
import Qualifying from './components/Qualifying';
import Gallery from './components/Gallery';
import RaceFormat from './components/RaceFormat';
import ServerConfig from './components/ServerConfig';
import Rules from './components/Rules';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <Features />
      <Registration />
      <Awards />
      <Qualifying />
      <Gallery />
      <RaceFormat />
      <ServerConfig />
      <Rules />
      <FAQ />
      <FinalCTA />
      <Footer />
    </div>
  );
}
